/* eslint-disable react/no-danger */
import React, { Component } from 'react';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import LazyLoad from 'react-lazy-load';
import AdBlockDetect from 'react-ad-block-detect';
import { connect } from 'react-redux';
import { withApollo } from 'react-apollo';

import {
  Segment,
  Divider,
  Header,
  Container,
  Grid,
  Image,
  Dropdown,
  Accordion,
  Icon,
  Checkbox,
  Tab,
  Menu
} from 'semantic-ui-react';
import { toast } from 'react-toastify';
import _ from 'lodash';
import moment from 'moment';

import Images from '../../assets/Images';

import * as AppActions from '../../actions';
import './PresentationDetail.css';
import { getRawAdName, checkIfAdIsForInstagram } from '../../utils/ad.common';
import { restructureCampaign } from '../../utils/campaignRestructuring';
import { updatePreviewLinkUrl } from '../../utils/urls';
import domains from '../../containers/Domains';
import { formatMonthYear } from '../../utils/format';
import { getAds } from '../../fbApi/Ad';
// import { getCampaign } from '../../fbApi/Campaign';
import { getAdPreview } from '../../fbApi/AdPreview';
import { getCanvas } from '../../fbApi/Canvas';
import getLead from '../../fbApi/Lead';
import { SwipeableModal } from './../../components/common/SwipeableModal/SwipeableModal';
import AdListRow from '../../components/common/PresentaionAdList/AdListRow/AdListRow';
import AdThumbnail from '../../components/common/PresentaionAdList/AdThumbnail/AdThumbnail';
import { makeGetWithoutTokenParam } from '../../services/ServiceManager';

class PresentationDetail extends Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired
  };

  state = {
    compareMobDesk: false,
    expandAll: false,
    showAccountsList: false,
    selectedMonth: '',
    isIE: false || !!document.documentMode,
    accountOptions: null,
    expiredAt: '',
    linkExpired: false,
    loadingAds: false,
    campaigns: [],
    accountTitle: null,
    dataLoaded: false,
    showTutorialStep: '',
    presentation: {
      id: null,
      data: null,
      url: null
    },
    campaignMonth: {
      PRODUCT_CATALOG_SALES: [],
      LEAD_GENERATION: [],
      VIDEO_VIEWS: [],
      LINK_CLICKS: [],
      CONVERSIONS: [],
      REACH: [],
      MESSAGES: [],
      POST_ENGAGEMENT: [],
      OUTCOME_TRAFFIC: [],
      OUTCOME_SALES: []
    },
    token: null,
    mobileState: {
      selectedMenu: '',
      campaignKey: '',
      previews: [],
      selectedPreview: null,
      selectedAdName: '',
      modalPresented: false
    },
    campaignList: {
      LINK_CLICKS: 'Traffic Ads',
      VIDEO_VIEWS: 'Video Ads',
      LEAD_GENERATION: 'Lead Generation',
      PRODUCT_CATALOG_SALES: 'Dynamic Ads',
      CONVERSIONS: 'Site Visits',
      REACH: 'Reach Ads',
      MESSAGES: 'Messenger Ads',
      POST_ENGAGEMENT: 'Post Engagement',
      OUTCOME_TRAFFIC: 'Outcome Traffic',
      OUTCOME_SALES: 'Outcome Sales'
    },
    currentCampaignTab: '',
    selectedTabIndex: 0,
    activeAccordionItemIndex: null,
    errorOnLoad: false
  };

  async componentDidMount() {
    await this.init();
  }

  componentWillReceiveProps(nextProps) {
    const { presentationData } = nextProps;
    const { dataLoaded, loadingAds } = this.state;
    if (presentationData) {
      const { presentationDetail } = presentationData;
      if (presentationDetail) {
        const { statusCode, presentation } = presentationDetail;
        if (statusCode && statusCode === 200 && presentation) {
          const { cachedquery, expired_at: expiredAt } = presentation;
          const cachedQuery = JSON.parse(cachedquery);
          const {
            is_multiple_accounts: isMultipleAccounts,
            account_id: accountIds,
            campaign_ids: campaignIds,
            month_year: monthYear
          } = cachedQuery;

          if (isMultipleAccounts) {
            this.setState((prevState) => ({
              ...prevState,
              campaigns: campaignIds
            }));
            this.getAdAccounts(accountIds, campaignIds);
          } else if (!dataLoaded && !loadingAds) {
            this.loadAdsForSingleAccount(campaignIds[0].value);
          }

          this.setState((prevState) => ({
            ...prevState,
            expandAll: false,
            presentation: {
              ...presentation
            },
            showAccountsList: isMultipleAccounts,
            selectedMonth: monthYear,
            linkExpired: false,
            expiredAt
          }));
        } else {
          this.setState((prevState) => ({
            ...prevState,
            expandAll: false,
            showAccountsList: false,
            linkExpired: true
          }));
        }
      }
    }
  }

  init = async () => {
    const resultToken = await makeGetWithoutTokenParam('token/public');
    const { statusCode, token } = resultToken;
    if (statusCode === 200) {
      this.setState(
        (prevState) => ({ ...prevState, token }),
        () => {
          const { match, actions } = this.props;
          const host =
            window.location.hostname !== 'localhost'
              ? domains[window.location.hostname]
              : domains['lambda-functions'];
          const url = `${host}preview/${match.params.url}`;
          actions.fetchPresentationData(url);
        }
      );
    }
  };

  activeCampaigns = () => {
    const campaigns = this.state.campaignMonth;
    let activeCampaigns = 0;

    const campaignKeys = Object.keys(campaigns);
    campaignKeys.forEach((key) => {
      if (campaigns[key].length > 0) {
        activeCampaigns = activeCampaigns + 1;
      }
    });
    return activeCampaigns;
  };

  handleExpandAll = async () => {
    this.nextStep(4);
    const { expandAll, campaignMonth, token } = this.state;
    if (expandAll) {
      this.setState((prevState) => ({ ...prevState, expandAll: false }));
    } else {
      const campaignKeys = Object.keys(campaignMonth);

      const newCampaignMonth = await Promise.all(
        campaignKeys.map(async (campaignKey) => {
          const currentCampaign = campaignMonth[campaignKey];
          const newCampaign = await Promise.all(
            currentCampaign.map(async (preview) => {
              const { ad_id: previewAdId } = preview;
              const formats = [
                'DESKTOP_FEED_STANDARD',
                'MOBILE_FEED_STANDARD',
                'INSTAGRAM_STORY'
              ];
              const newAdPreview = { ...preview };
              let desktopUrl = '';
              let mobileUrl = '';
              let instagramUrl = '';

              const fbPreviews = await Promise.all(
                formats.map(async (format) => {
                  const result = await getAdPreview(previewAdId, format, token);
                  return Promise.resolve(result);
                })
              );

              if (fbPreviews && fbPreviews.length > 0) {
                const { data: desktopIframeData } = fbPreviews[0] || {};
                const { data: mobileIframeData } = fbPreviews[1] || {};
                const { data: instagramIframeData } = fbPreviews[2] || {};
                const { body: desktopIframeBody } = desktopIframeData[0] || {};
                const { body: mobileIframeBody } = mobileIframeData[0] || {};
                const { body: instagramIframeBody } =
                  instagramIframeData[0] || {};

                desktopUrl = desktopIframeBody || '';
                mobileUrl = mobileIframeBody || '';
                instagramUrl = instagramIframeBody || '';
              }

              newAdPreview.desktop_iframe_url = desktopUrl;
              newAdPreview.mobile_iframe_url = mobileUrl;
              newAdPreview.instagram_iframe_url = instagramUrl;

              return Promise.resolve(newAdPreview);
            })
          );
          return Promise.resolve(newCampaign);
        })
      );

      const result = {};
      for (let i = 0; i < campaignKeys.length; i += 1) {
        Object.defineProperty(result, campaignKeys[i], {
          value: newCampaignMonth[i],
          writable: false,
          enumerable: true
        });
      }

      this.setState((prevState) => ({
        ...prevState,
        campaignMonth: result,
        expandAll: true
      }));
    }
  };

  handleCompareDefault = () => {
    this.setState(
      (prevState) => ({
        ...prevState,
        compareMobDesk: !this.state.compareMobDesk
      }),
      () => {
        if (this.state.compareMobDesk) {
          this.setSelectedTabIndex(2);
        } else {
          this.setSelectedTabIndex(0);
        }
      }
    );
  };

  setSelectedTabIndex = (index = 0, callback = null) => {
    this.setState(
      (prevState) => ({
        ...prevState,
        selectedTabIndex: index
      }),
      callback
    );
  };

  getAdAccounts = (accounts, campaigns) => {
    const accountOptions = _.sortBy(
      _.map(campaigns, (op, index) => ({
        key: index,
        value: op.accountId,
        text: accounts.filter((account) => account.value === op.accountId)[0]
          .name
      })),
      'text'
    );

    this.setState((prevState) => ({ ...prevState, accountOptions }));
  };

  onAccountSelect = (event, data) => {
    const accountTitle = `${
      data.options.filter((option) => option.value === data.value)[0].text
    } - ${formatMonthYear(this.state.selectedMonth)}`;

    this.setState(
      (prevState) => ({
        ...prevState,
        campaignMonth: {
          PRODUCT_CATALOG_SALES: [],
          LEAD_GENERATION: [],
          VIDEO_VIEWS: [],
          LINK_CLICKS: [],
          CONVERSIONS: [],
          REACH: [],
          MESSAGES: [],
          POST_ENGAGEMENT: [],
          OUTCOME_TRAFFIC: [],
          OUTCOME_SALES: []
        },
        loadingAds: true,
        dataLoaded: false,
        accountTitle
      }),
      () => {
        const accountCampaigns = this.state.campaigns.filter(
          (account) => account.accountId === data.value
        );
        if (accountCampaigns && accountCampaigns.length > 0) {
          this.getAds(accountCampaigns[0].value.split(','));
        }
      }
    );
  };

  getAds = (ids) => {
    this.setState(
      (prevState) => ({
        ...prevState,
        previews: [],
        campaignIds: ids,
        doneLoading: false
      }),
      async () => {
        try {
          const { token, presentation, campaignList } = this.state;
          let newCampaignList = { ...campaignList };
          const allCampaigns = await Promise.all(
            _.map(ids, async (id) => {
              // kept code in case we need to revert changes
              // const campaign = await getCampaign(id, token);
              // const { id: campaignId } = campaign || {};
              const resultAds = await getAds(id, token);
              const ads = resultAds.data || [];

              const previewObjects = ads.map(async (ad) => {
                const resultAd = await this.buildPreviewObject(ad);
                return Promise.resolve(resultAd);
              });
              return Promise.all(previewObjects);
            })
          );

          const cachedQuery = JSON.parse(presentation.cachedquery);
          const { ads_ids: adsIds, is_custom_ads: isCustomAds } =
            cachedQuery || {};
          const selectedAds = adsIds || {};
          // const selectedAdKeys = Object.keys(selectedAds);
          // const wasCampaignMonthRestructured =
          //   selectedAdKeys.indexOf('MODEL_BASED') !== -1;

          let mappedCampaignMonth = {};
          let flattenedCampaignsArray = [];

          allCampaigns.forEach((campaign) => {
            const { campaign_objective: campaignObjective } = campaign[0] || {};
            mappedCampaignMonth[campaignObjective] = [];
            flattenedCampaignsArray = flattenedCampaignsArray.concat(campaign);
          });

          flattenedCampaignsArray.forEach((ad) => {
            const { campaign_objective: campaignObjective } = ad || {};
            mappedCampaignMonth[campaignObjective].push(ad);
          });

          // if (wasCampaignMonthRestructured) {
          const {
            campaignMonth: restructuredCampaignMonth
          } = restructureCampaign(mappedCampaignMonth);
          if (restructuredCampaignMonth) {
            mappedCampaignMonth = restructuredCampaignMonth;
            newCampaignList = {
              MODEL_BASED: 'Model Ads',
              DEALERSHIP_BRANDING: 'Branding Ads',
              OFFERS: 'Offer Ads'
            };
          }
          // }
          if (isCustomAds) {
            const selectedAdKeys = Object.keys(selectedAds);
            const flattenedSelectedAds = [];
            selectedAdKeys.forEach((key) => {
              if (selectedAds[key] && selectedAds[key].length > 0) {
                selectedAds[key].forEach((ad) => {
                  flattenedSelectedAds.push(ad);
                });
              }
            });

            const campaignMonthObjectKeys = Object.keys(mappedCampaignMonth);
            campaignMonthObjectKeys.forEach((key) => {
              const ads = [];
              flattenedSelectedAds.forEach((selectedAd) => {
                const foundAd = mappedCampaignMonth[key].find(
                  (ad) => selectedAd.id === ad.ad_id
                );
                if (foundAd) {
                  ads.push(foundAd);
                }
              });
              mappedCampaignMonth[key] = ads;
            });
          }

          this.setState(
            (prevState) => ({
              ...prevState,
              campaignMonth: mappedCampaignMonth,
              campaignList: newCampaignList
            }),
            async () => {
              // to need to scroll to current accordion item
              await this.setActiveAccordionItemFromUrlParams();
            }
          );
        } catch (error) {
          this.setState(
            (prevState) => ({
              ...prevState,
              loadingAds: false,
              dataLoaded: true,
              errorOnLoad: true,
              campaignMonth: {},
              currentCampaignTab: '',
              selectedTabIndex: 0,
              activeAccordionItemIndex: null
            }),
            () => {
              toast('There was an error loading ad previews for this page.', {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 4000,
                type: toast.TYPE.ERROR,
                hideProgressBar: false
              });
            }
          );
        }
      }
    );
  };

  setActiveAccordionItemFromUrlParams = async () => {
    const { campaignMonth, token } = this.state;
    const urlParamsObject = this.returnUrlParamsObject() || {};
    const { category, index, format } = urlParamsObject || {};
    const previewTabIndices = {
      mobile: 0,
      desktop: 1,
      compare: 2,
      instagram: 3
    };

    const campaignKeyFromUrlParam =
      category.trim() !== '' ? category.toUpperCase() : null;

    let foundAd = null;

    if (campaignKeyFromUrlParam && campaignMonth[campaignKeyFromUrlParam]) {
      foundAd = campaignMonth[campaignKeyFromUrlParam][index];
    }

    if (foundAd) {
      const adWithPreviews = await this.returnAdWithPreviews(foundAd, token);
      foundAd = adWithPreviews;
    }

    const campaignKeys = Object.keys(campaignMonth);
    const firstCampaignWithAds = campaignKeys.find(
      (key) => campaignMonth[key] && campaignMonth[key].length > 0
    );
    const campaignTabToUse =
      foundAd &&
      campaignKeyFromUrlParam &&
      campaignKeyFromUrlParam.trim() !== ''
        ? campaignKeyFromUrlParam
        : firstCampaignWithAds;

    this.setState(
      (prevState) => ({
        ...prevState,
        loadingAds: false,
        dataLoaded: true,
        campaignMonth,
        currentCampaignTab: campaignTabToUse,
        selectedTabIndex: previewTabIndices[format],
        activeAccordionItemIndex: foundAd ? index : null
      }),
      () => {
        this.manageTutorialCookie();
        if (foundAd) {
          this.scrollToAccordionItem(index);
        }
      }
    );
  };

  returnUrlParamsObject = () => {
    const url = window.location.href;
    const decodedUrl = decodeURIComponent(url);
    const urlParts = decodedUrl.split('#');
    const urlParamsObject = {
      category: 'model_based',
      index: 0,
      format: 'mobile'
    };
    if (urlParts[1]) {
      const paramKeys = Object.keys(urlParamsObject);
      const params = urlParts[1].split('&');
      paramKeys.forEach((key) => {
        const stringAtIndex = _.find(
          params,
          (param) => param && param.indexOf(`${key}=`) !== -1
        );
        const splitValueString = stringAtIndex ? stringAtIndex.split('=') : '';
        const paramValue = splitValueString[1] || '';
        if (paramValue && paramValue.trim() !== '')
          // only convert index to int for now
          urlParamsObject[key] =
            key === 'index' ? parseInt(paramValue, 10) : paramValue;
      });
    }
    return urlParamsObject;
  };

  scrollToAccordionItem = (index) => {
    try {
      const height = window.innerHeight;

      const selectedItem = document
        .querySelector('.App-content')
        .querySelector(`#accordionItem-${index}`);

      const elementRect = selectedItem
        ? selectedItem.getBoundingClientRect()
        : {};

      const { top } = elementRect || {};
      const topToUse = !top ? height : top - 55.72;
      document
        .querySelector('.App-content')
        .scrollTo({ top: topToUse, left: 0, behavior: 'auto' });
    } catch (error) {
      console.log('Error in scrollToAccordionItem(): ', error);
    }
  };

  setCurrentCampaignTab = (event, { activeIndex }) => {
    const { campaignMonth } = this.state;
    const campaignKeys = Object.keys(campaignMonth).filter(
      (key) => campaignMonth[key] && campaignMonth[key].length > 0
    );
    const keyAtIndex = campaignKeys[activeIndex] || '';
    this.setState(
      (prevState) => ({
        ...prevState,
        currentCampaignTab: keyAtIndex,
        activeAccordionItemIndex: null
      }),
      () => {
        const urlParams = this.returnUrlParamsObject();
        const { index, format } = urlParams;
        updatePreviewLinkUrl(keyAtIndex.toLowerCase(), index, format);
        this.nextStep(1);
      }
    );
  };

  handleAccordionClick = async (index, adId, campaignKey) => {
    this.nextStep(2);
    const {
      campaignMonth,
      token,
      activeAccordionItemIndex,
      selectedTabIndex,
      compareMobDesk
    } = this.state;
    const newActiveAccordionItemIndex =
      index === activeAccordionItemIndex ? null : index;
    let newSelectedTabIndex = selectedTabIndex;

    const possibleAds = campaignMonth[campaignKey];
    let ad = possibleAds.find((obj) => obj.ad_id === adId);
    if (ad) {
      const adWithPreviews = await this.returnAdWithPreviews(ad, token);
      ad = adWithPreviews;

      if (compareMobDesk) {
        const { desktop_iframe_url: desktopIframeUrl } = ad;
        newSelectedTabIndex = desktopIframeUrl.includes(
          'This ad type is mobile-only'
        )
          ? 0
          : 2;
      }
    } else {
      toast(`The ad could not be loaded. Refresh and try again.`, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 4000,
        type: toast.TYPE.WARNING,
        hideProgressBar: false
      });
    }
    this.setState(
      (prevState) => ({
        ...prevState,
        currentCampaignTab: ad ? campaignKey : '',
        activeAccordionItemIndex: ad ? newActiveAccordionItemIndex : null,
        selectedTabIndex: ad ? newSelectedTabIndex : 0
      }),
      () => {
        const { activeAccordionItemIndex: newAccordionIndex } = this.state;
        const urlParams = this.returnUrlParamsObject();
        const { format } = urlParams;
        updatePreviewLinkUrl(
          campaignKey.toLowerCase(),
          newAccordionIndex || 0,
          format
        );
        this.scrollToAccordionItem(index || newAccordionIndex);
      }
    );
  };

  loadSwipeableModalPreview = async (index = null) => {
    const { token, mobileState } = this.state;
    const { selectedPreview, previews } = mobileState;
    const newPreviews = [...previews];
    const adWithPreview = await this.returnAdWithPreviews(
      index ? previews[index] : selectedPreview,
      token
    );
    if (index) {
      newPreviews[index] = adWithPreview;
    } else {
      const foundPreviewIndex = previews.findIndex(
        (preview) => preview.ad_id === selectedPreview.ad_id
      );
      if (foundPreviewIndex !== -1) {
        newPreviews[foundPreviewIndex] = selectedPreview;
      }
    }

    this.setState({
      mobileState: {
        ...mobileState,
        selectedPreview: adWithPreview,
        previews: newPreviews
      }
    });
  };

  returnAdWithPreviews = async (inputAd, token) => {
    const ad = inputAd;
    const { campaign, campaign_objective: campaignObjective } = ad || {};
    const { objective } = campaign || {};
    const objectiveToCheck = objective || campaignObjective;
    try {
      const { ad_name: adName, ad_id: adId } = ad;
      const result = await Promise.all([
        getAdPreview(adId, 'DESKTOP_FEED_STANDARD', token),
        getAdPreview(adId, 'MOBILE_FEED_STANDARD', token),
        getAdPreview(adId, 'INSTAGRAM_STORY', token)
      ]);

      const [desktopResult, mobileResult, instagramResult] = result;
      const { data: desktopData } = desktopResult || {};
      const { data: mobileData } = mobileResult || {};
      const { data: instagramData } = instagramResult || {};
      const { body: desktopIframeBody } = desktopData[0] || {};
      const { body: mobileIframeBody } = mobileData[0] || {};
      const { body: instagramIframeBody } = instagramData[0] || {};

      if (desktopIframeBody) {
        ad.desktop_iframe_url = desktopIframeBody
          .replace('height="450"', 'height="580"')
          .replace('width="540"', 'width="720"');
      }
      if (mobileIframeBody) {
        ad.mobile_iframe_url = mobileIframeBody
          .replace('height="450"', 'height="520"')
          .replace('width="540"', 'width="520"');
      }
      if (instagramIframeBody) {
        ad.instagram_iframe_url = instagramIframeBody;
      }

      if (adName.split('Collection').length > 1) {
        ad.desktop_iframe_url =
          '<span style="height: 720px; width: 720px;">This ad type is mobile-only, so no desktop preview exists.</span>';
      }

      if (adName.split('Canvas').length > 1) {
        ad.desktop_iframe_url =
          '<span style="height: 720px; width: 720px;">No Desktop I-frame exists for this ad type</span>';
      }

      if (
        adName.split('360').length > 1 &&
        objectiveToCheck === 'VIDEO_VIEWS'
      ) {
        ad.mobile_iframe_url = ad.mobile_iframe_url.replace(
          'height="720"',
          'height="300"'
        );
        ad.mobile_iframe_url +=
          '<div class="ui segment floated left inline text" style="position:absolute; top: 25em; width:320px"><p>Due to differences in hardware, mobile 360 video cannot be previewed via desktop.</p><p>Please use the desktop preview window to view your content.</p></div>';
      }

      ad.mobile_iframe_url = ad.mobile_iframe_url.replace(
        'scrolling="yes"',
        'scrolling="no"'
      );
      return Promise.resolve(ad);
    } catch (error) {
      return Promise.resolve(ad);
    }
  };

  handlePreviewTabChange = (e, { activeIndex }) => {
    this.nextStep(3);
    const previewTabIndices = {
      0: 'mobile',
      1: 'desktop',
      2: 'compare',
      3: 'instagram'
    };

    this.setState(
      (prevState) => ({
        ...prevState,
        selectedTabIndex: activeIndex
      }),
      () => {
        const urlParams = this.returnUrlParamsObject();
        const { category, index } = urlParams;
        updatePreviewLinkUrl(category, index, previewTabIndices[activeIndex]);
      }
    );
  };

  manageTutorialCookie = () => {
    const { isIE } = this.state;
    const { user, cookies } = this.props;
    const { email: userEmail } = user || {};
    if (!isIE) {
      const cookieName = userEmail || 'anonymous';
      let cookieValue = cookies.get(cookieName);
      cookieValue = cookieValue ? parseInt(cookieValue, 10) + 1 : 0;
      const step = this.activeCampaigns() > 1 ? 1 : 2;
      const tutorialStep = cookieValue < 2 ? step : '';
      this.setState(
        (prevState) => ({ ...prevState, showTutorialStep: tutorialStep }),
        () => {
          cookieValue = cookieValue >= 2 ? 2 : cookieValue;
          cookies.set(cookieName, cookieValue, { path: '/' });
        }
      );
    }
  };

  buildPreviewObject = async (ad) => {
    let isCarousel = false;
    let canvasName = {};
    let leadFormName = {};
    let destinations = [];
    let startTime;
    let endTime;

    const {
      creative,
      campaign,
      adset,
      effective_status: effectiveStatus,
      name: adName,
      id: adId
    } = ad;

    const { thumbnail_url: thumbnailUrl } = creative || {};

    const {
      start_time: campaignStartTime,
      stop_time: campaignStopTime,
      objective
    } = campaign || {};

    const { name: adsetName } = adset || {};

    try {
      const { object_story_spec: objectStorySpec } = creative || {};
      let currentLink = null;

      if (objectStorySpec) {
        const {
          link_data: linkData,
          video_data: videoData,
          call_to_action: callToAction,
          template_data: templateData
        } = objectStorySpec;

        if (linkData) {
          const {
            child_attachments: childAttachments,
            link,
            call_to_action: linkDataCta
          } = linkData;

          if (childAttachments) {
            isCarousel = true;
            childAttachments.forEach((lVar) => {
              destinations.push(lVar.link);
            });
          }

          if (link) {
            currentLink = link;
            destinations.push(currentLink);
          }

          if (linkDataCta) {
            const { value: linkDataCtaVal } = linkDataCta;
            const { lead_gen_form_id: leadGenFormId } = linkDataCtaVal || {};
            if (linkDataCtaVal && leadGenFormId) {
              try {
                leadFormName = await getLead(leadGenFormId, this.state.token);
              } catch (error) {
                console.log('lead form permission error');
                leadFormName = 'You need permission to access this Lead Form';
              }
              destinations = [];
            }
          }
        }

        // video cta
        if (videoData) {
          const { call_to_action: videoDataCta } = videoData;
          const { value: videoDataCtaVal } = videoDataCta || {};
          if (videoDataCta && videoDataCtaVal) {
            currentLink = videoDataCtaVal.link;
            destinations.push(currentLink);
          }
        }

        if (callToAction) {
          const { link: ctaLink } = callToAction;
          if (ctaLink) {
            currentLink = ctaLink;
            destinations.push(currentLink);
          }
        }
        if (templateData) {
          const { link: templateDataLink } = templateData;
          if (templateDataLink) {
            currentLink = templateDataLink;
            destinations.push(currentLink);
          }
        }
      }
    } catch (e) {
      console.log('urls error', e);
      destinations = [];
    }

    let isCanvas = false;
    destinations.map(async (destinationLink) => {
      if (destinationLink && destinationLink.split('canvas_doc').length > 1) {
        isCanvas = true;
        canvasName = await getCanvas(
          _.last(destinationLink.split('/')),
          this.state.token
        );
      }
    });

    if (isCanvas) {
      destinations = [];
    }

    if (campaignStartTime && campaignStopTime) {
      startTime = Date.parse(campaignStartTime);
      startTime = new Date(startTime);
      startTime = startTime.toLocaleString('en-us', {
        month: 'long',
        day: '2-digit',
        year: 'numeric'
      });

      endTime = Date.parse(campaignStopTime);
      endTime = new Date(endTime);
      endTime = endTime.toLocaleString('en-us', {
        month: 'long',
        day: '2-digit',
        year: 'numeric'
      });
    }

    const previewObject = {
      start_time: startTime,
      end_time: endTime,
      destination_url: destinations,
      lead_form_name: leadFormName,
      canvas_name: canvasName,
      adset_name: adsetName || '',
      ad_title: isCarousel ? [] : '',
      ad_status: effectiveStatus,
      ad_name: adName || '',
      ad_id: adId,
      campaign_objective: objective,
      desktop_iframe_url: null,
      mobile_iframe_url: null,
      instagram_iframe_url: null,
      image_url: thumbnailUrl || ''
    };
    return previewObject;
  };

  loadAdsForSingleAccount = (ids) => {
    this.setState(
      (prevState) => ({
        ...prevState,
        loadingAds: true,
        dataLoaded: false
      }),
      () => {
        this.getAds(ids);
      }
    );
  };

  renderLink = (link, key) => {
    if (typeof link === 'string') {
      return (
        <div key={key} className="ad-link">
          <strong>
            <a href={link} target="_new">
              {link}
            </a>
          </strong>
        </div>
      );
    }
    if (link && link.name) {
      return (
        <div key={key}>
          <strong>{link.name}</strong>
        </div>
      );
    }
    return null;
  };

  renderLeadFormName = (obj) =>
    obj.name ? (
      <div>
        Lead Form Name: <strong>{obj.name}</strong>
      </div>
    ) : null;

  showCanvas = (canvasId) => {
    window.FB.ui(
      {
        display: 'popup',
        method: 'instant_experiences_preview',
        canvas_id: canvasId
      },
      (res) => {
        return res;
      }
    );
  };

  renderCanvasName = (obj) =>
    obj.name ? (
      <div>
        Canvas Name: <strong>{obj.name}</strong>
      </div>
    ) : null;

  renderDestinationUrls = (urls) =>
    urls.length > 0 ? (
      <div>
        This Ad links to:
        {urls.map((link, key) => this.renderLink(link, key))}
      </div>
    ) : null;

  getTabAds = (preview) => {
    const onlyMobile = preview.desktop_iframe_url
      ? preview.desktop_iframe_url.indexOf('mobile-only') >= 0
      : false;
    const isInstagramAd = checkIfAdIsForInstagram(preview);
    const desktopAd = {
      menuItem: { key: 'Desktop', icon: <Icon size="large" name="desktop" /> },
      render: () => <Tab.Pane>{this.renderDesktopAd(preview)}</Tab.Pane>
    };

    const mobileAd = {
      menuItem: { key: 'Mobile', icon: <Icon size="big" name="mobile" /> },
      render: () => <Tab.Pane>{this.renderMobileAd(preview)}</Tab.Pane>
    };

    const instagramStoryAd = {
      menuItem: {
        key: 'Instagram Story',
        icon: <Icon size="big" name="instagram" />
      },
      render: () => <Tab.Pane>{this.renderInstgramStoryAd(preview)}</Tab.Pane>
    };
    const mobileDesktop = (
      <div className="icons-container">
        <Icon size="big" name="mobile" /> +{' '}
        <Icon className="icon-desktop" size="large" name="desktop" />
      </div>
    );
    const mobileAndDesktop = {
      menuItem: { key: 'Mobile & Desktop', icon: mobileDesktop },
      render: () => (
        <Tab.Pane className="mobile-desktop-pane">
          <Grid columns={2} divided>
            <Grid.Row>
              <Grid.Column>{this.renderMobileAd(preview)}</Grid.Column>
              <Grid.Column>{this.renderDesktopAd(preview)}</Grid.Column>
            </Grid.Row>
          </Grid>
        </Tab.Pane>
      )
    };

    if (onlyMobile) {
      return [mobileAd];
    }

    if (isInstagramAd) {
      return [instagramStoryAd];
    }

    return [
      mobileAd,
      desktopAd,
      mobileAndDesktop,
      isInstagramAd ? instagramStoryAd : {}
    ];
  };

  renderMobileAd = (preview) => (
    <div>
      <h4>Mobile Ad Preview</h4>
      <AdBlockDetect>
        <div className="Ad-Blocker-Message">
          Please disable your ad blocker, and refresh this tab
        </div>
      </AdBlockDetect>
      <div className="filler" />
      <div style={{ maxWidth: 320 }}>
        <LazyLoad height={620} offsetVertical={900}>
          <span
            dangerouslySetInnerHTML={this.createSafeHtml(
              preview.mobile_iframe_url
            )}
          />
        </LazyLoad>
      </div>
    </div>
  );
  renderDesktopAd = (preview) => (
    <div>
      <h4>Desktop Ad Preview</h4>
      <AdBlockDetect>
        <div className="Ad-Blocker-Message">
          Please disable your ad blocker, and refresh this tab
        </div>
      </AdBlockDetect>
      <div className="filler" />
      <div style={{ maxWidth: 720 }}>
        <LazyLoad height={762} offsetVertical={1500}>
          <span
            dangerouslySetInnerHTML={this.createSafeHtml(
              preview.desktop_iframe_url
            )}
          />
        </LazyLoad>
      </div>
    </div>
  );
  renderInstgramStoryAd = (preview) => (
    <div>
      <h4>Instagram Story Ad Preview</h4>
      <AdBlockDetect>
        <div className="Ad-Blocker-Message">
          Please disable your ad blocker, and refresh this tab
        </div>
      </AdBlockDetect>
      <div className="filler" />
      <div>
        <LazyLoad height={567} offsetVertical={1500}>
          <span
            dangerouslySetInnerHTML={this.createSafeHtml(
              preview.instagram_iframe_url
            )}
          />
        </LazyLoad>
      </div>
    </div>
  );

  createSafeHtml = (encodedHtml) => {
    return {
      __html: _.unescape(encodedHtml)
    };
  };

  renderAdTabs = (adTabs) => {
    const { selectedTabIndex } = this.state;

    return (
      <Tab
        panes={adTabs}
        activeIndex={selectedTabIndex}
        onTabChange={this.handlePreviewTabChange}
      />
    );
  };

  renderPreviewsAccordion = (sortedPreviews, campaignKey) => {
    const {
      currentCampaignTab,
      activeAccordionItemIndex,
      expandAll
    } = this.state;
    const renderTitles = (preview, index) => {
      const isAccordionItemActive =
        (index === activeAccordionItemIndex &&
          campaignKey === currentCampaignTab) ||
        expandAll;
      return (
        <div id={`accordionItem-${index}`}>
          <Accordion.Title
            active={isAccordionItemActive}
            index={index}
            onClick={() =>
              this.handleAccordionClick(index, preview.ad_id, campaignKey)
            }
          >
            <Icon name="dropdown" />
            {getRawAdName(preview.ad_name)}
          </Accordion.Title>
          {this.renderContentAccordion(preview, index, isAccordionItemActive)}
        </div>
      );
    };

    return (
      <Accordion className="tabs-container" fluid styled>
        {sortedPreviews.map((preview, index) => renderTitles(preview, index))}
      </Accordion>
    );
  };

  renderContentAccordion = (preview, index, isAccordionItemActive) => {
    const { showTutorialStep } = this.state;
    const {
      destination_url: destinationUrl,
      lead_form_name: leadFormName,
      canvas_name: canvasName
    } = preview || {};
    const adTabs = this.getTabAds(preview);
    return (
      <Accordion.Content active={isAccordionItemActive}>
        <div
          key={index}
          className="header-container generic-content custom-generic-content"
          style={{ padding: 0 }}
        >
          <Segment
            basic
            className="custom-generic-content"
            style={{ padding: 0 }}
          >
            {this.renderDestinationUrls(destinationUrl)}
            {leadFormName ? this.renderLeadFormName(leadFormName) : null}
            {canvasName ? this.renderCanvasName(canvasName) : null}
            <Divider hidden />
            {showTutorialStep === 3 ? (
              <div
                className="tooltip"
                role="button"
                tabIndex={0}
                onClick={() => this.nextStep(3)}
              >
                <div className="switch-mode-step tooltiptext">
                  Switch between mobile, desktop, and side-by-side views
                  <div
                    onClick={this.finishTutorial}
                    role="button"
                    tabIndex={0}
                    className="tooltip-switch-mode-step close-tooltip"
                  >
                    <span className="close-content">X</span>
                  </div>
                </div>
              </div>
            ) : null}

            {this.renderAdTabs(adTabs)}
          </Segment>
        </div>
      </Accordion.Content>
    );
  };

  renderPresentationTab = (previews, campaignKey) => {
    // const sortedPreviews = _.sortBy([...previews], 'adset_name'); // this prevents previews from loading
    const sortedPreviews = previews;
    return sortedPreviews.length > 0 ? (
      <Container className="left-flush custom-container-flush">
        {this.renderPreviewsAccordion(sortedPreviews, campaignKey)}
      </Container>
    ) : null;
  };

  renderCampaignsTabs = (campaignMonth) => {
    const { currentCampaignTab } = this.state;

    //  I left this in case the users want Facebook sorting back.
    // const campaignKeys = Object.keys(campaignMonth);
    // const isCampaignMonthRestructured =
    //   campaignKeys.indexOf('MODEL_BASED') !== -1;
    // const campaignList = isCampaignMonthRestructured
    //   ? {
    //       MODEL_BASED: 'Model Ads',
    //       DEALERSHIP_BRANDING: 'Branding Ads',
    //       OFFERS: 'Offer Ads'
    //     }
    //   : {
    //       LINK_CLICKS: 'Traffic Ads',
    //       VIDEO_VIEWS: 'Video Ads',
    //       LEAD_GENERATION: 'Lead Generation',
    //       PRODUCT_CATALOG_SALES: 'Dynamic Ads',
    //       CONVERSIONS: 'Site Visits',
    //       REACH: 'Reach Ads',
    //       MESSAGES: 'Messenger Ads'
    //     };

    try {
      const campaignList = {
        MODEL_BASED: 'Model Ads',
        DEALERSHIP_BRANDING: 'Branding Ads',
        OFFERS: 'Offer Ads'
      };

      if (!Object.keys) {
        Object.keys = (object) => {
          if (object !== Object(object))
            throw new TypeError('Object.keys called on non-object');
          const keys = [];
          let prop;
          for (prop in object)
            if (Object.prototype.hasOwnProperty.call(object, prop)) {
              keys.push(prop);
            }
          return keys;
        };
      }

      const campaignListKeys = Object.keys(campaignList).filter(
        (key) => campaignMonth[key] && campaignMonth[key].length > 0
      );

      if (!campaignListKeys || campaignListKeys.constructor !== Array) {
        throw new TypeError('The campaignListKeysObject is not an Array');
      }

      if (campaignListKeys.length <= 0) {
        throw new Error('There are no campaign keys to use');
      }

      const currentActiveIndex = campaignListKeys.findIndex(
        (key) => key === currentCampaignTab
      );

      const tabs = campaignListKeys.map((key) => ({
        menuItem: campaignList[key],
        render: () => {
          return (
            <Tab.Pane
              active={key === currentCampaignTab}
              className="container-no-border"
            >
              {this.renderPresentationTab(campaignMonth[key], key)}
            </Tab.Pane>
          );
        }
      }));

      return (
        <div>
          {this.state.showTutorialStep === 1 ? (
            <div className="tooltip">
              <div
                onClick={() => this.nextStep(1)}
                role="button"
                tabIndex={0}
                className="select-campaigns-step tooltiptext"
              >
                Select between different campaigns
                <div
                  onClick={this.finishTutorial}
                  role="button"
                  tabIndex={0}
                  className="tooltip-select-campaigns-step close-tooltip"
                >
                  <span className="close-content">X</span>
                </div>
              </div>
            </div>
          ) : null}
          <Tab
            activeIndex={currentActiveIndex}
            onTabChange={this.setCurrentCampaignTab}
            panes={tabs}
          />
        </div>
      );
    } catch (error) {
      console.log('Error Occurred in renderCampaignsTabs():', error);
      toast('There was an error loading this page.', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 4000,
        type: toast.TYPE.ERROR,
        hideProgressBar: false
      });
      return <div>{this.loadingErrorMessage}</div>;
    }
  };

  loadingErrorMessage = (
    <Header as="h5" color="red" block>
      <Icon name="close" />
      <Header.Content>
        The selected previews could not be loaded. It is recommended that the
        lastest version of Google Chrome, Firefox, or Safari be used to view
        this page. If you are using one of these browsers, try refreshing the
        page or visiting this page later.
      </Header.Content>
    </Header>
  );

  nextStep = (step, newExpandAll) => {
    const { expandAll, showTutorialStep } = this.state;
    if (newExpandAll) {
      if (!expandAll) {
        this.setState({
          expandAll: !expandAll,
          selectedTabIndex: 0
        });
      }
    }

    const currentStep = showTutorialStep;
    if (step === currentStep) {
      const nextStep = currentStep === 4 ? '' : currentStep + 1;
      this.setState((prevState) => ({
        ...prevState,
        showTutorialStep: nextStep
      }));
    }
  };

  // to do: refctor of tutorial: when the user closes one step tooltip, the next one should appear
  // until the user completes all steps
  startTutorial = () => {
    const step = this.activeCampaigns() > 1 ? 1 : 2;
    this.setState((prevState) => ({ ...prevState, showTutorialStep: step }));
  };

  finishTutorial = (e) => {
    this.setState(
      (prevState) => ({
        ...prevState,
        showTutorialStep: ''
      }),
      () => {
        e.stopPropagation();
      }
    );
  };

  renderPatentPendingLogo = () => (
    <div className="logo-patent-pending-share-link">
      <Image
        src={Images.patentPending}
        className="App-patent-pending"
        alt="patentPending"
        size="medium"
      />
    </div>
  );

  renderPresentationStateTitle = () => {
    const {
      presentation,
      showAccountsList,
      accountTitle,
      selectedMonth
    } = this.state;
    if (presentation && presentation.data) {
      const preData = JSON.parse(presentation.data);
      if (showAccountsList) {
        return accountTitle !== null ? accountTitle : 'Please select account';
      }
      const presentationName = preData.title
        .replace(selectedMonth, '')
        .replace('CUSTOM -', '');
      return `${presentationName} - ${selectedMonth}`;
    }
    return '';
  };

  renderPresentation = () => {
    const {
      linkExpired,
      expiredAt,
      errorOnLoad,
      loadingAds,
      dataLoaded,
      showTutorialStep,
      expandAll,
      compareMobDesk,
      isIE,
      showAccountsList,
      accountOptions,
      campaignMonth
    } = this.state;
    const { presentationData } = this.props;
    const loading = presentationData ? presentationData.loading : true;
    const error = presentationData ? presentationData.error : false;
    if (error) {
      return <p>{error.message}</p>;
    }
    if (loading) {
      return <p>Loading ...</p>;
    } else if (linkExpired) {
      return (
        <div>
          <div className="text-expires">
            {expiredAt && expiredAt !== '' ? (
              <ul className="text-expires-list">
                <li>Share link expires on:</li>
                <li>{moment(expiredAt, 'YYYY-MM-DD')}</li>
              </ul>
            ) : null}
          </div>
          <div className="div-link-expired">
            <p>
              <b>LINK EXPIRED</b>
            </p>
            <p>
              This link has expired and its ad previews are no longer viewable.
            </p>
            <p>
              Please contact your account manager to receive an updated link.
            </p>
          </div>
          <div className="logo-patent-pending-expired">
            {this.renderPatentPendingLogo()}
          </div>
        </div>
      );
    }

    return (
      <div>
        <Grid>
          <Grid.Row>
            <Grid.Column width={15}>
              <Header
                as="h1"
                className="custom-header"
                style={{ width: '100%' }}
              >
                <Image
                  src={Images.alexiaGoldLogoSm}
                  alt="logo"
                  className="floated left inline tiny"
                />
                <span className="floated left inline">
                  {this.renderPresentationStateTitle()}
                  {!isIE ? (
                    <span
                      className="tutorial-circle"
                      role="button"
                      tabIndex={0}
                      onClick={this.startTutorial}
                    >
                      ?
                    </span>
                  ) : null}
                </span>
              </Header>
              <Header as="p" className="expires-text-container">
                <label htmlFor="expires-text-container">
                  Share link expires {moment(expiredAt, 'YYYY-MM-DD').fromNow()}
                </label>
              </Header>
            </Grid.Column>
            <Grid.Column width={1}>
              <Image
                src={Images.patentPending}
                alt="Patent Pending"
                style={{ opacity: 0.5 }}
                className="floated right inline small"
              />
            </Grid.Column>
          </Grid.Row>
          {isIE ? (
            <Grid.Row>
              <Grid.Column>
                <p className="emptyAdsMessage">
                  Alexia works best on Chrome or Firefox. You may encounter
                  issues while using Internet Explorer
                </p>
              </Grid.Column>
            </Grid.Row>
          ) : null}

          {!errorOnLoad ? (
            <Grid.Row>
              <Grid.Column>
                <div className="presentation-account-expiration-container">
                  <div className="text-expires presentation-expires">
                    {!loadingAds && dataLoaded ? (
                      <ul className="text-expires-list">
                        <li className="list-divider expand-all-container">
                          {showTutorialStep === 4 ? (
                            <div
                              className="tooltip"
                              role="button"
                              tabIndex={0}
                              onClick={() => this.nextStep(4)}
                            >
                              <div className="tooltiptext expand-all-step-for-preview">
                                Click &quot;Expand All&quot; to view all ads
                                <div
                                  onClick={this.finishTutorial}
                                  role="button"
                                  tabIndex={0}
                                  className="tooltip-expand-all-step close-tooltip"
                                >
                                  <span className="close-content">X</span>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          <strong>Expand all</strong>{' '}
                          <Checkbox
                            toggle
                            onChange={this.handleExpandAll}
                            checked={expandAll}
                          />
                        </li>

                        <li className="compare-mobile-desktop-container">
                          <strong>Compare Mobile &amp; Desktop</strong>{' '}
                          <Checkbox
                            toggle
                            onChange={this.handleCompareDefault}
                            checked={compareMobDesk}
                          />
                        </li>
                      </ul>
                    ) : null}
                  </div>
                </div>
              </Grid.Column>
            </Grid.Row>
          ) : null}

          {showAccountsList ? (
            <Grid.Row>
              <Grid.Column width={16}>
                <div className="presentation-account-container">
                  <p>
                    <Dropdown
                      placeholder="Ad Accounts"
                      search
                      selection
                      options={accountOptions}
                      onChange={this.onAccountSelect}
                      className="accounts-dropwdon"
                    />
                  </p>
                </div>
              </Grid.Column>
            </Grid.Row>
          ) : null}

          <Grid.Row>
            <Grid.Column width={16}>
              {loadingAds ? <p>Loading Ads...</p> : null}
              {errorOnLoad ? <div>{this.loadingErrorMessage}</div> : null}
              {dataLoaded && !errorOnLoad ? (
                <div className="container">
                  <div>
                    {showTutorialStep === 2 ? (
                      <div className="tooltip">
                        <div
                          onClick={() => this.nextStep(2, true)}
                          role="button"
                          tabIndex={0}
                          className="drawers-step tooltiptext"
                        >
                          Click drawers to view individual ads
                          <div
                            onClick={this.finishTutorial}
                            role="button"
                            tabIndex={0}
                            className="tooltip-drawers-step close-tooltip"
                          >
                            <span className="close-content">X</span>
                          </div>
                        </div>
                      </div>
                    ) : null}
                    {this.renderCampaignsTabs(campaignMonth)}
                  </div>
                </div>
              ) : null}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  };

  renderPresentationOnMobile = () => {
    const {
      linkExpired,
      expiredAt,
      errorOnLoad,
      loadingAds,
      dataLoaded,
      showTutorialStep,
      isIE,
      showAccountsList,
      accountOptions,
      campaignMonth,
      mobileState
    } = this.state;
    const { modalPresented, selectedPreview, previews } = mobileState;

    const { presentationData } = this.props;
    const loading = presentationData ? presentationData.loading : true;
    const error = presentationData ? presentationData.error : false;

    if (error) {
      return <p>{error.message}</p>;
    }

    if (loading) {
      return <p>Loading ...</p>;
    } else if (linkExpired) {
      return (
        <div>
          <div className="text-expires">
            {expiredAt && expiredAt !== '' ? (
              <ul className="text-expires-list">
                <li>Share link expires on:</li>
                <li>{moment(expiredAt, 'YYYY-MM-DD')}</li>
              </ul>
            ) : null}
          </div>
          <div className="div-link-expired">
            <p>
              <b>LINK EXPIRED</b>
            </p>
            <p>
              This link has expired and its ad previews are no longer viewable.
            </p>
            <p>
              Please contact your account manager to receive an updated link.
            </p>
          </div>
          <div className="logo-patent-pending-expired">
            {this.renderPatentPendingLogo()}
          </div>
        </div>
      );
    }
    return (
      <div style={modalPresented ? { overflow: 'hidden' } : {}}>
        <div className="mobile-content-header">
          <Grid>
            <Grid.Row>
              <Grid.Column width={3}>
                <Image
                  src={Images.alexiaGoldLogoSm}
                  alt="logo"
                  className="inline"
                />
              </Grid.Column>
              <Grid.Column width={13}>
                <Header as="h1" style={{ width: '100%', fontSize: '1.5rem' }}>
                  <span className="inline">
                    {this.renderPresentationStateTitle()}
                  </span>
                </Header>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ padding: 0 }}>
              <Grid.Column width={13} />
              <Grid.Column width={3}>
                <Image
                  src={Images.patentPending}
                  alt="Patent Pending"
                  style={{ opacity: 0.5 }}
                  className="inline"
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Header as="p" className="expires-text-container">
                  <label htmlFor="expires-text-container">
                    Share link expires{' '}
                    {moment(expiredAt, 'YYYY-MM-DD').fromNow()}
                  </label>
                </Header>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
        <Divider hidden />

        {isIE ? (
          <p className="emptyAdsMessage">
            Alexia works best on Chrome or Firefox. You may encounter issues
            while using Internet Explorer
          </p>
        ) : null}

        {showAccountsList ? (
          <div className="presentation-account-container">
            <p>
              <Dropdown
                placeholder="Ad Accounts"
                search
                selection
                options={accountOptions}
                onChange={this.onAccountSelect}
                className="accounts-dropwdon"
              />
            </p>
          </div>
        ) : null}
        <Divider hidden />

        {loadingAds ? <p>Loading Ads...</p> : null}

        {dataLoaded ? (
          <div className="container">
            {!errorOnLoad ? (
              <div
                className={
                  showAccountsList
                    ? 'campaigns-tabs-container-mult'
                    : 'campaigns-tabs-container'
                }
              >
                {showTutorialStep === 2 ? (
                  <div className="tooltip">
                    <div
                      onClick={() => this.nextStep(2, true)}
                      role="button"
                      tabIndex={0}
                      className="drawers-step tooltiptext"
                    >
                      Click drawers to view individual ads
                      <div
                        onClick={this.finishTutorial}
                        role="button"
                        tabIndex={0}
                        className="tooltip-drawers-step close-tooltip"
                      >
                        <span className="close-content">X</span>
                      </div>
                    </div>
                  </div>
                ) : null}
                {this.renderAdsListOnMobile(campaignMonth)}
              </div>
            ) : null}
          </div>
        ) : null}

        {dataLoaded && selectedPreview ? (
          <SwipeableModal
            resetMobileStateOnModalClose={this.resetMobileStateOnModalClose}
            loadSwipeableModalPreview={this.loadSwipeableModalPreview}
            renderAdTitleImage={this.renderAdTitleImage}
            renderAdDetail={this.renderAdDetail}
            getAdName={this.getAdName}
            selectedPreview={selectedPreview}
            previews={previews}
          />
        ) : null}
      </div>
    );
  };

  renderAdsListOnMobile = (campaignMonth) => {
    const {
      mobileState,
      campaignList,
      campaignMonth: campaignMonthState
    } = this.state;
    const filteredKeys = _.sortBy(
      _.filter(
        Object.keys(campaignList),
        (key) => campaignMonth[key] && campaignMonth[key].length > 0
      )
    );

    if (mobileState.selectedMenu === '') {
      mobileState.campaignKey = filteredKeys[0];
      mobileState.selectedMenu = campaignList[filteredKeys[0]];
      mobileState.previews = campaignMonthState[mobileState.campaignKey];
    }

    const menuItems = filteredKeys.map((key, index) => {
      const keyIndex = index;
      return (
        <Menu.Item
          key={keyIndex}
          name={campaignList[key]}
          active={mobileState.selectedMenu === campaignList[key]}
          onClick={(event, data) => {
            this.setState({
              mobileState: {
                selectedMenu: data.name,
                campaignKey: key,
                previews: campaignMonth[key],
                selectedAdName: '',
                selectedPreview: null
              }
            });
          }}
        >
          {campaignList[key]}
        </Menu.Item>
      );
    });

    const adListItems = mobileState.previews.map((preview) => {
      const { ad_id: adId, image_url: imageUrl, ad_name: adName } = preview;
      return (
        <div key={adId}>
          <AdListRow
            key={`${adId}-ad-list-row`}
            imageSrc={imageUrl}
            title={this.getAdName(adName)}
            onClick={() => {
              this.blockScrollOnContainer(true);
              this.setState(
                {
                  mobileState: {
                    ...mobileState,
                    selectedAdName: this.getAdName(adName),
                    selectedPreview: preview,
                    modalPresented: true
                  }
                },
                async () => {
                  await this.loadSwipeableModalPreview();
                }
              );
            }}
          />
          <Divider style={{ margin: '3px', marginLeft: 0, marginRight: 0 }} />
        </div>
      );
    });

    const adList = (
      <ul
        style={{
          listStyleType: 'none',
          padding: 0
        }}
      >
        {adListItems.map((element, index) => {
          const elementIndex = index;
          return (
            <li
              key={elementIndex}
              style={{
                width: '100%',
                position: 'relative'
              }}
            >
              {element}
            </li>
          );
        })}
      </ul>
    );
    return (
      <div>
        <Menu fluid widths={menuItems.length}>
          {menuItems}
        </Menu>
        {adList}
      </div>
    );
  };

  renderAdDetail = (preview) => (
    <Segment>
      <div style={{ width: '100%', height: '9em' }}>
        <AdThumbnail
          src={preview.image_url}
          customStyle={{
            float: 'right',
            margin: '0',
            width: '8em',
            height: '8em'
          }}
        />
      </div>

      <Divider />

      {this.renderDestinationUrls(preview.destination_url)}
      {preview.lead_form_name
        ? this.renderLeadFormName(preview.lead_form_name)
        : null}
      {preview.canvas_name ? this.renderCanvasName(preview.canvas_name) : null}

      <Divider />
      {this.renderMobileAd(preview)}
    </Segment>
  );

  renderAdTitleImage = (preview) => (
    <Segment>
      <div style={{ width: '100%', height: '9em' }}>
        <Image
          size="tiny"
          src={preview.image_url}
          floated="right"
          style={{ margin: '0', width: '8em', height: '8em' }}
        />
      </div>

      <Divider />
    </Segment>
  );

  getAdName = (name) => {
    // strip the name by _ and take the last two words.
    const splitWords = _.split(name, '_');
    if (name.trim() === '') return '** The ad name is empty.';
    if (splitWords.length === 0) return name; // Since the name does not contain _, we do not know how to parse the name. Just return the name.
    if (splitWords.length === 1) return splitWords[0];
    if (splitWords.length === 2) return _.join(splitWords, ' ');

    const lastTwoWords = splitWords.slice(-2);

    return _.join(lastTwoWords, ' ');
  };

  resetMobileStateOnModalClose = () => {
    this.blockScrollOnContainer(false);

    this.setState({
      ...this.state,
      mobileState: {
        ...this.state.mobileState,
        selectedPreview: null,
        selectedAdName: '',
        modalPresented: false
      }
    });
  };

  blockScrollOnContainer = (block) => {
    const selected = document.getElementsByClassName('App-content');
    if (block) {
      for (let i = 0; i < selected.length; i += 1) {
        selected[i].style.position = 'fixed';
        selected[i].style.overflow = 'hidden';
      }
    } else {
      for (let j = 0; j < selected.length; j += 1) {
        selected[j].style.position = 'absolute';
        selected[j].style.overflowX = 'hidden';
        selected[j].style.overflowY = 'scroll';
      }
    }
  };

  isScreenLoadedOnMobile = () => {
    const screenSize = window.innerWidth;
    const loadedOnMobileScreen = screenSize <= 414;

    return loadedOnMobileScreen;
  };
  render() {
    const loadedOnMobileScreen = this.isScreenLoadedOnMobile();

    if (loadedOnMobileScreen) {
      return (
        <div className="container" style={{ width: '100%' }}>
          <div
            className={`${
              this.state.showAccountsList ? 'expand-area' : ''
            } generic-content custom-generic-content`}
          >
            <Segment className="share-links-container" basic>
              {this.renderPresentationOnMobile()}
            </Segment>
          </div>
        </div>
      );
    }
    return (
      <div className="container" style={{ width: '100%' }}>
        <div
          className={`${
            this.state.showAccountsList ? 'expand-area' : ''
          } generic-content custom-generic-content`}
        >
          <Segment className="share-links-container" basic>
            {this.renderPresentation()}
          </Segment>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  presentationData: state.presentation
});

const mapDispatchToProps = (dispatch) => ({
  actions: {
    fetchPresentationData: (url) => {
      dispatch(AppActions.fetchPresentation(url));
    }
  }
});

export default withApollo(
  withCookies(connect(mapStateToProps, mapDispatchToProps)(PresentationDetail))
);



// WEBPACK FOOTER //
// ./src/screens/Presentation/PresentationDetail.js